import './Spinner.css';

const Spinner = ({ fullPage = false, label = 'Cargando' }: { fullPage?: boolean; label?: string }) => (
  <div className={`spinner-container${fullPage ? ' spinner-container--page' : ''}`} role="status" aria-live="polite">
    <span className="spinner" aria-hidden="true" />
    <span className="sr-only">{label}</span>
  </div>
);

export default Spinner;
